import { computed } from 'vue';

import { useOrgStore } from '@/shared/model';

export const useIam = () => {
  const orgStore = useOrgStore();

  // const rightsReadAllowed = ['read-only', 'read-write'];
  const rightsWriteAllowed = ['read-write'];
  const rightsReadForbidden = ['no-right'];

  const rolesApproved = computed(() => orgStore.userInfo.approved_roles);
  // const rights = computed(() => orgStore.userInfo.gen_rights_kk);

  const isReadAllowed = computed(() => {
    const rolesApprovedVal = rolesApproved.value;

    if (!rolesApprovedVal.length) return false;

    if (rightsReadForbidden.some(i => rolesApprovedVal.includes(i)))
      return false;
    return true;

    // const rightsVal = rights.value;
    // return rightsReadAllowed.some(i => rightsVal.includes(i));
  });

  const isWriteAllowed = computed(() => {
    if (!isReadAllowed.value) return false;

    const rolesApprovedVal = rolesApproved.value;
    return rightsWriteAllowed.some(i => rolesApprovedVal.includes(i));
  });

  const allRoles = orgStore.userInfo?.all_roles_kk;
  const isAdminOrMsh = computed(
    () => allRoles.includes('msh') || allRoles.includes('admin')
  );

  const init = () => {
    orgStore.init();
  };

  return { isReadAllowed, isWriteAllowed, isAdminOrMsh, init };
};
